export default __webpack_public_path__ + "static/media/postSuvinil10.c13e8754.gif";